import { Routes } from '@angular/router';

export const faqsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/faqs/faqs.component').then(c => c.FaqsComponent),
    data: { pageTitle: 'PAGES.FAQS.TITLE', pageType: 'list', isAnonymous: true }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-faq/add-edit-faq.component').then(c => c.AddEditFaqComponent),
    data: { pageTitle: 'PAGES.FAQS.ADD', pageType: 'add', isAnonymous: true }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-faq/add-edit-faq.component').then(c => c.AddEditFaqComponent),
    data: { pageTitle: 'PAGES.FAQS.EDIT', pageType: 'edit', isAnonymous: true }
  }
];


